import EmotesV2AnnouncementModal from './EmotesV2AnnouncementModal'

export default EmotesV2AnnouncementModal
